import React, { useState, useEffect } from 'react';
import { useTheme } from 'styled-components';
import { useSpring } from 'react-spring';
import PropTypes from 'prop-types';

import {
  Checkbox,
  AnimatedSwitch,
  AnimatedNotch,
  On,
  Off,
  StyledToggle
} from './Styles';

import Label from '../Label';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isChecked: PropTypes.bool,
  onClick: PropTypes.func,
  byPassUpdate: PropTypes.bool,
  testId: PropTypes.string
};

const defaultProps = {
  children: undefined,
  className: undefined,
  isChecked: false,
  onClick: () => undefined,
  byPassUpdate: false,
  testId: undefined
};

const Toggle = ({
  children,
  className,
  isChecked,
  onClick,
  byPassUpdate,
  testId
}) => {
  const [checked, setChecked] = useState(isChecked);
  const handleClick = () => {
    if (onClick) onClick();
    if (!byPassUpdate) setChecked(!checked);
  };
  const themeColors = useTheme().COLORS;
  const switchAnimation = useSpring({
    backgroundColor: checked ? themeColors.TERTIARY : themeColors.NEUTRAL
  });
  const animationProps = useSpring({
    left: !checked ? -1 : 0,
    transform: `translateX(${!checked ? '0%' : '100%'})`
  });

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  return (
    <StyledToggle className={className}>
      <Label.Inline>{children}</Label.Inline>
      <Checkbox defaultChecked={checked} />
      <AnimatedSwitch
        style={switchAnimation}
        data-testid={testId}
        onClick={handleClick}
      >
        <AnimatedNotch style={animationProps}>
          {checked ? <On /> : <Off />}
        </AnimatedNotch>
      </AnimatedSwitch>
    </StyledToggle>
  );
};

Toggle.propTypes = propTypes;
Toggle.defaultProps = defaultProps;

export default Toggle;
